import { render, staticRenderFns } from "./VSelection.vue?vue&type=template&id=191d847a&scoped=true&"
import script from "./VSelection.vue?vue&type=script&lang=js&"
export * from "./VSelection.vue?vue&type=script&lang=js&"
import style0 from "./VSelection.vue?vue&type=style&index=0&id=191d847a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d847a",
  null
  
)

export default component.exports